import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function OpenHomes(this: ListingsService, listing: Listing, currentValue: boolean): boolean {
  // If no value is set, do not affect the filter.
  if (!this.filteringService.openHomes()) {
    return currentValue;
  }

  // Determine if the listing matches the filter.
  if (!listing.openToday && !listing.openTomorrow) {
    return false;
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
